export default "__VITE_ASSET__BnOq_VZ2__"